import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import OrgChart from "@/pages/OrgChart";
export const Route = createFileRoute("/org-chart")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><OrgChart /></ProtectedRoute>) });
